import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';

@Component({
    selector: 'voucher-tab',
    templateUrl: './voucher.component.html',
})
export class VoucherTransactionComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    //@Input() dataContext;
    
    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    numCtrl: FormControl;
    modelCtrl: FormControl;
    dateCtrl: FormControl;
    branchCtrl: FormControl;
    amtCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    // stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    paymentList = [];
    actModelList = [];
    stockDet = [];
    branchList: any[] = [];
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'stock_id',
        orderDir: 'desc'
    };
   

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;
    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            // hasValidParty.bind(this)
        ]);


        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);


        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare") {
                retVal = { inValidType: true };
            }

            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);

        // this.stockDet = [];
        // this.stockDet['mode'] = 'Add';

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);
        this.numCtrl = new FormControl('', [
            Validators.required
        ]);
        this.amtCtrl = new FormControl('', [
            // Validators.required,
            Validators.pattern(/^[0-9]+$/)
        ]);
        this.dateCtrl = new FormControl('', [
            Validators.required
        ]);

    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }

    ngOnInit(): void {
        this.typeList = ['Delete', 'Update'];
        this.paymentList = ['Card'];
        this.stockDet['voucher_date'] = new Date();

        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });

    }

   
    onVoucherUpdateDelete(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };
       if(this.stockDet['voucher_date'])
       {
        this.stockDet['voucher_date'] = moment(this.stockDet['voucher_date']).format('YYYY-MM-DD');
       }
       else{
        this.stockDet['voucher_date'] ='';
       }
       if(this.stockDet['upd_voucher_date'])
       {
        this.stockDet['upd_voucher_date'] = moment(this.stockDet['upd_voucher_date']).format('YYYY-MM-DD');
       }
       else{
        this.stockDet['upd_voucher_date'] ='';
       }
        let that = this,
            data = {
                stock_type: this.stockDet['stock_type'],
                voucher_no: this.stockDet['voucher_no'],                
                voucher_date: this.stockDet['voucher_date'],               
                upd_voucher_date: this.stockDet['upd_voucher_date'],
                upd_amount: this.stockDet['upd_amount'],
                upd_type: this.stockDet['upd_type'],
                branch_id:this.stockDet['branch_id'],
            };

        if (this.stockDet['stock_type'] == 'Delete') {

            if (data.branch_id == undefined || data.branch_id == '') {
                swal('WARNING', 'Please Enter Branch');
                return;
            }
            if (data.voucher_no == undefined || data.voucher_no == '') {
                swal('WARNING', 'Please Enter Voucher Number');
                return;
            }
            if (data.voucher_date == undefined) {
                swal('WARNING', 'Please Enter Voucher Date');
                return;
            }

            swal({
                title: 'Are you sure to Delete?',
                text: 'You will not be able to Recover Voucher No: ' + data.voucher_no + ' Again!',
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete!',
                cancelButtonText: 'No, Keep it'
            }).then(function() {
                that.isLoading = true;
                that.isLoadMask = that.commonService
                .deleteVoucherAmount(data)
                    .then(function(res: any) {

                        that.isLoading = false;
                        if (res.success) {
                            that.stockDet = [];
                            swal('SUCCESS', res.message, 'success');
                            that.stockDet['voucher_date'] = new Date();
                            //  that.onReset();
                            // that.getStockList();
                        } else {
                            
                            var toast = {
                                type: 'error',
                                title: 'ERROR',
                                body: res.message
                            };
                            that.toasterService.pop(toast);
                        }
                    });
    
            }, function(dismiss) {
    
            });


            // this.isLoading = true;
            // this.commonService
            //     .deleteVoucherAmount(data)
            //     .then(function (res: any) {
            //                 that.isLoading = false;
            //                 if (res.success) {
            //                     // that.stockDet = [];
            //                     swal('SUCCESS', res.message, 'success');
            //                     //  that.onReset();
            //                     // that.getStockList();
            //                 } else {
            //                     var toast = {
            //                         type: 'error',
            //                         title: 'ERROR',
            //                         body: res.message
            //                     };
            //                     that.toasterService.pop(toast);
            //                 }
            //             });
        }else {
            if (data.branch_id == undefined || data.branch_id == '') {
                swal('WARNING', 'Please Enter Branch');
                return;
            }
            if (data.voucher_no == undefined || data.voucher_no == '') {
                swal('WARNING', 'Please Enter Voucher Number');
                return;
            }
            if (data.voucher_date == undefined ) {
                swal('WARNING', 'Please Enter Voucher Date');
                return;
            }
            if (data.upd_amount || data.upd_type || data.upd_voucher_date) {
            }
            else{
                swal('WARNING', 'Please Enter Update Date/Amount/Type');
                return;
            }
            // if ((data.upd_amount == undefined ||data.upd_amount == '' ) && (data.upd_type == undefined || data.upd_type == '' ) && (data.upd_voucher_date == undefined || data.upd_voucher_date == '')) {
            //     swal('WARNING', 'Please Enter Update Date/Amount/Type');
            //     return;
            // }
          
            this.isLoading = true;
            this.commonService
                .updateVoucherDetails(data)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.stockDet = [];
                        swal('SUCCESS', res.message, 'success');
                        that.stockDet['voucher_date'] = new Date();
                        //  that.onReset();
                        // that.getStockList();
                    } else {
                        var toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: res.message
                        };
                        that.toasterService.pop(toast);
                    }
                });


        }
       
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/voucherDetails/voucher.component.ts